import './style.scss';
import $ from 'jquery';
import jQueryBridget from 'jquery-bridget';
import Masonry from 'masonry-layout';
import Isotope from 'isotope-layout';
import imagesloaded from 'imagesloaded';
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

jQueryBridget('isotope', Isotope, $);
jQueryBridget( 'imagesloaded', imagesloaded, $ );
gsap.registerPlugin(ScrollTrigger);

function isoFunction() {
	const container = $('.wp-block-thefuturblocks-portfolio.has-masonry-grid');
	if(container.length) {

		if($(".wp-block-thefuturblocks-portfolio__thumbnail.has-sh").length > 0) {
			gsap.set(".wp-block-thefuturblocks-portfolio__thumbnail.has-sh",{height:360});
		}
		container.imagesloaded(() => {
			container.isotope({
				itemSelector: '.has-columns-grid',
				percentPosition: true,
				masonry: {
					columnWidth: '.has-columns-grid',
				}
			});
			gsap.set(container,{autoAlpha:1});
			function portFunction() {
				if($(".wp-block-thefuturblocks-portfolio__header-wrapper.header-animation").length > 0) {
					$(".wp-block-thefuturblocks-portfolio__article").each(function() {
						var self = $(this),
							inner = self.find(".wp-block-thefuturblocks-portfolio__inner"),
							image = self.find(".wp-block-thefuturblocks-portfolio__image"),
							wrapper = self.find(".wp-block-thefuturblocks-portfolio__header-wrapper"),
							header = self.find(".wp-block-thefuturblocks-portfolio__header"),
							catsWrapper = self.find(".wp-block-thefuturblocks-portfolio__cats-wrapper"),
							title = self.find(".wp-block-thefuturblocks-portfolio__title"),
						    tl = gsap.timeline({paused:true});

						tl.fromTo(wrapper, {xPercent:-100}, {duration: 0.4, xPercent:0, ease:"sine.out"})
						.fromTo(header, {xPercent:100}, {duration: 0.4, xPercent:0, ease:"sine.out"}, "<")
						.to(image, {duration: 0.5, scale:1.05, ease:"sine.out"}, "<")
						.fromTo(title, {autoAlpha:0,x:10}, {autoAlpha:1,x:0,duration: 0.4, ease:"sine.out"}, "<")
						.fromTo(catsWrapper, {autoAlpha:0,x:10}, {autoAlpha:1,x:0,duration: 0.4, ease:"sine.out"}, "<0.1");

						inner.on("mouseenter", () => {
							tl.play();
						}).on("mouseleave", () => {
							tl.reverse();
						})
					})
				}
			}
			portFunction();

			function btnFunction() {
				if($(".wp-block-thefuturblocks-portfolio__button-wrapper").length) {
					$(".wp-block-thefuturblocks-portfolio__button-wrapper").each(function() {
						var self = $(this),
							link = self.find('.wp-block-thefuturblocks-portfolio__button-link'),
							before = self.find('.wp-block-thefuturblocks-portfolio__button-before'),
						    text = self.find('.wp-block-thefuturblocks-portfolio__button-text'),
						    dataHoverTextColor = link.attr("data-tcolor"),
						    dataHoverBorderColor = link.attr("data-bcolor"),
						    tl = gsap.timeline({paused:true});

						tl.fromTo(before, {scale:0}, {duration: 0.3, scale:1})
						.to(text, {duration: 0.3, color: dataHoverTextColor,ease: "sine.in"}, "<")
						.to(link, {duration: 0.3, borderColor: dataHoverBorderColor}, "<");

						link.on("mouseenter", () => {
							tl.play();
						}).on("mouseleave", () => {
							tl.reverse();
						})
						
						self.on("mousemove", callMoveIn);
						self.on("mouseleave", callMoveOut);

						function callMoveIn(e){
						  moveIn(e, link, 50);
						}

						function callMoveOut(){
						  moveOut(link);
						}

						function moveIn(e, target, movement){
						  var boundingRect = self[0].getBoundingClientRect();
						  var relX = e.clientX - boundingRect.left;
						  var relY = e.clientY - boundingRect.top;

						  gsap.to(target, {
						    duration: 0.3,
						    x: (relX - boundingRect.width/2) / boundingRect.width * movement,
						    y: (relY - boundingRect.height/2) / boundingRect.width * movement,
						    ease: "sine.out",
						    overwrite: "auto"
						  });
						}

						function moveOut(target){
						  gsap.to(target, {
						    duration: 0.3,
						    x: 0,
						    y: 0,
						    overwrite: "auto"
						  });
						}
					})
				}
			}
			btnFunction();
			ScrollTrigger.refresh(true);

		});
	}
}

function revealFunction() {
	if($(".wp-block-thefuturblocks-portfolio__article.anim-reveal").length) {

		gsap.set('.wp-block-thefuturblocks-portfolio__article.anim-reveal', {autoAlpha:1,xPercent:-100});
		gsap.set('.wp-block-thefuturblocks-portfolio__inner', {xPercent:100});
		if($(".wp-block-thefuturblocks-portfolio__button-wrapper").length) {
			gsap.set('.wp-block-thefuturblocks-portfolio__button-wrapper', {autoAlpha:0, y:40});
		}

		ScrollTrigger.batch(".wp-block-thefuturblocks-portfolio__article.anim-reveal", {
		  onEnter: batch => {
		    batch.forEach((section, i) => {
		      gsap.to(section, {
		      	xPercent: 0,
		        duration: 0.6,
		        stagger: 0.1,
		        delay: i * 0.3,
		        ease: "power2.inOut"
		      });
		      gsap.to(section.querySelectorAll(".wp-block-thefuturblocks-portfolio__inner"), {
		        xPercent: 0,
		        duration: 0.6,
		        stagger: 0.1,
		        delay: i * 0.3,
		        ease: "power2.inOut"
		      });
		    });
		  },
  		  once: true,
		  start: "+=100 bottom",
		});

		if($(".wp-block-thefuturblocks-portfolio__button-wrapper").length) {
			$(".wp-block-thefuturblocks-portfolio__button-wrapper").each(function() {
				var self = $(this);
				
			    var tl = gsap.to(self, {duration:0.6,y:0,autoAlpha:1,delay:0.6});

				var st = ScrollTrigger.create({
					trigger: self,
					start: "+=100 bottom",
	    			toggleActions: "play none none none",
					animation: tl
				});
			});
		}
	}
}
$(window).on('load', () => {
	if($('.c-loader').length) {
		gsap.delayedCall(4, function() {
			revealFunction();
		})
	} else {
		gsap.delayedCall(0.4, function() {
			revealFunction();
		})
	}
	isoFunction();
})